/* eslint no-unused-vars: 0 */
/* eslint vars-on-top: 0 */
/* eslint import/no-unresolved: 0 */
/* eslint no-use-before-define: 0 */
/* eslint no-undef: 0 */
/* eslint no-plusplus: 0 */
/* eslint import/no-extraneous-dependencies: 0 */

// On remplace les require() par des imports ES6
import $ from 'jquery';
import 'bootstrap';

// On expose jQuery globalement pour que Bootstrap et vos scripts puissent s'en servir
window.$ = $;
window.jQuery = $;

console.log('Log from app.js');

window.formInit = function () {
  if (sessionStorage.getItem('cas_server') != null) {
    $('#serverGroup input').val(sessionStorage.getItem('cas_server'));
  }
  
  $('#serverGroup a').click(function (e) {
    e.preventDefault(); // Évite que le clic sur les liens "#" fasse remonter la page en haut
    $('#serverGroup input').val($(this).text());
  });
  
  $('form').change(() => {
    if ($('#protocolGroup select').val() === 'oidc') {
      $('#scopeGroup').removeClass('d-none');
    } else {
      $('#scopeGroup').addClass('d-none');
    }
  });
  
  $('form').submit(() => {
    sessionStorage.setItem('cas_server', $('#serverGroup input').val());
    window.location.hash = '#test';
  });
};